import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddUser, MstCompliance } from '../_models';
import { Threshold } from '../_models/threshold';
import { environment } from '../../environments/environment';
import { MstContracts } from '../_models/mst-contracts';
@Injectable({
  providedIn: 'root'
})
export class AdminService {
  
  Url=  environment.ApiUrl + "auth";
  AdminUrl=environment.ApiUrl +"admin";
  constructor(private http: HttpClient ) { }

  checkComplianceDetails() {
    return this.http.get<boolean>(`${this.AdminUrl}/checkcompliance`);
}

getSupplierContractorList(SupplierID:string) {
  return this.http.get<any[]>(`${this.AdminUrl}/getsuppconlist/${SupplierID}`);
}

addContractData(addContract:MstContracts) {
  return this.http.post(`${this.AdminUrl}/addContract`,addContract);
}


addUser(addUser:AddUser)
  {
    return this.http.post(`${this.AdminUrl}/adduser`,addUser);
  }

  deleteUser(addUser:AddUser)
  {
    return this.http.post(`${this.AdminUrl}/deleteuser`,addUser);
  }
  deleteContract(deleteContract:MstContracts)
  {
    return this.http.post(`${this.AdminUrl}/deleteContract`,deleteContract);
  }

  viewUsers() {
    return this.http.get<AddUser[]>(`${this.AdminUrl}/viewusers`);
}

  UpdateCompliance(transCompliance:MstCompliance)
  {
    return this.http.post(`${this.AdminUrl}/updatemstcompls`,transCompliance);
  }

viewMstCompliance() {
  return this.http.get<MstCompliance[]>(`${this.AdminUrl}/viewmstcompls`);
}

ViewMstThreshold() {
  return this.http.get<Threshold[]>(`${this.AdminUrl}/viewthreshold`);
}

AddThreshold(mstThreshold:Threshold)
  {
    return this.http.post(`${this.AdminUrl}/addthreshold`,mstThreshold);
  }
}
